import { Component, OnInit } from '@angular/core';
import { VersionStore } from './service/version.store';
import { LogService } from '../log/log.service';

@Component({
  selector: 'pioneer-version',
  templateUrl: './version.component.html'
})
export class VersionComponent implements OnInit {

  frontendVersionObj: Object = {};
  backendVersionObj: Object = {};

  constructor(private versionStore: VersionStore,
              private logService: LogService) {
  }

  ngOnInit() {
    this.versionStore.getFrontendVersion().subscribe(versionObj => {
      this.frontendVersionObj = versionObj;
    });
    this.versionStore.getBackendVersion().subscribe(versionObj => {
      this.backendVersionObj = versionObj;
    });
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/version/version.component.ts